import { render, staticRenderFns } from "./DoctorInfoSection.vue?vue&type=template&id=e22aaa0e"
import script from "./DoctorInfoSection.vue?vue&type=script&lang=js"
export * from "./DoctorInfoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports